import en from './en.json';
import da from './da.json';

export default {
    en: en,
    da: da
}
